import { 
    SPHERE_MIN, SPHERE_MAX, SPHERE_INCREMENT,
    CYLINDER_MIN, CYLINDER_MAX, CYLINDER_INCREMENT,
    AXIS_MIN, AXIS_MAX,
    ADD_MIN, ADD_MAX, ADD_INCREMENT,
    PRISM_BASE_OPTIONS
} from "./prescriptionConstants";

// Generate rx values from constants
export const sphereValues = [];
for (let i = SPHERE_MIN; i <= SPHERE_MAX; i += SPHERE_INCREMENT) {
    const value = i.toFixed(2);
    if (Math.abs(Number.parseFloat(value)) < Number.EPSILON) {
        sphereValues.push(Number.parseFloat(value).toFixed(2));
    } else {
        sphereValues.push(i > 0 ? `+${value}` : value);
    }
}

export const cylinderValues = [];
for (let i = CYLINDER_MAX; i >= CYLINDER_MIN; i -= CYLINDER_INCREMENT) {
    const value = i.toFixed(2);
    if (Math.abs(Number.parseFloat(value)) < Number.EPSILON) {
        cylinderValues.push(Number.parseFloat(value).toFixed(2));
    } else {
        cylinderValues.push(i > 0 ? `+${value}` : value);
    }
}

export const axisValues = Array.from({length: AXIS_MAX - AXIS_MIN + 1}, (_, i) => {
    const value = i + AXIS_MIN;
    return value.toString().padStart(3, '0');
});

export const addValues = [];
for (let i = ADD_MIN; i <= ADD_MAX; i += ADD_INCREMENT) {
    addValues.push(i.toFixed(2));
}

export const prismBaseValues = PRISM_BASE_OPTIONS.map(option => option.value);

// Utility functions to convert between display and database formats
export const formatForDisplay = {
    sphere: (value) => {
        if (value === null || value === undefined || value === '') {
            return '';
        }
        const numeric = typeof value === 'number' ? value : parseFloat(value);
        const fixed = numeric.toFixed(2);
        if (Math.abs(numeric) < Number.EPSILON) {
            return Number.parseFloat(fixed).toFixed(2);
        }
        return numeric > 0 ? `+${fixed}` : fixed;
    },
    cylinder: (value) => {
        if (value === null || value === undefined || value === '') {
            return '';
        }
        const numeric = typeof value === 'number' ? value : parseFloat(value);
        const fixed = numeric.toFixed(2);
        if (Math.abs(numeric) < Number.EPSILON) {
            return Number.parseFloat(fixed).toFixed(2);
        }
        return numeric > 0 ? `+${fixed}` : fixed;
    },
    axis: (value) => {
        if (value === null || value === undefined || value === '') {
            return '';
        }
        return value.toString().padStart(3, '0');
    },
    add: (value) => {
        if (value === null || value === undefined || value === '') {
            return '';
        }
        const numeric = typeof value === 'number' ? value : parseFloat(value);
        return numeric.toFixed(2);
    }
};

export const parseForDatabase = {
    sphere: (value) => value ? parseFloat(value.replace('+', '')) : null,
    cylinder: (value) => value ? parseFloat(value.replace('+', '')) : null,
    axis: (value) => value ? parseInt(value, 10) : null,
    add: (value) => value ? parseFloat(value) : null
};

export const rxModel = {
    customerId: null,
    practitionerId: '',
    rxDate: '',
    expiryDate: '',
    rxType: 'glasses',
    // OD fields
    odSph: '',
    odCyl: '',
    odAxis: '',
    odAdd: '',
    odPrism: '',
    odPrismBase: '',
    odDistPd: '',
    odNearPd: '',
    odVa: '',
    odBc: '',
    // OS fields
    osSph: '',
    osCyl: '',
    osAxis: '',
    osAdd: '',
    osPrism: '',
    osPrismBase: '',
    osDistPd: '',
    osNearPd: '',
    osVa: '',
    osBc: '',
    notes: '',
    status: 'active'
};